// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_68-6";
export var headerCell = "_68-2";
export var rowWrapper = "_68-4";
export var stickyAggregationCell = "_68-a";
export var stickyAggregationRow = "_68-7";
export var stickyColumnCell = "_68-9";
export var stickyColumnHeaderCell = "_68-8";
export var table = "_68-1";
export var virtualRowWrapper = "_68-5";
export var virtualTableContainer = "_68-0";
export var white = "_68-3";